import { http } from "./http.js";

async function getPosition(resource, id) {
  const response = await http.get(`/${resource}/${id === "0" ? "new" : id}`);
  return response;
}

async function updatePosition(resource, id, position) {
  const response = await http.put(`/${resource}/${id}`, position);
  return response;
}

async function createPosition(resource, position) {
  const response = await http.post(`/${resource}`, position);
  return response;
}

async function changeRemovedState(resource, id, isRemoved) {
  const response = await http.patch(
    `/${resource}/${id}/rpc/change-removed-state`,
    {
      value: !isRemoved,
    },
  );
  return response;
}

export { getPosition, updatePosition, createPosition, changeRemovedState };
